<template>
	<div class="main">
		<el-card class="card_box">
			<div
				slot="header"
				class="card_title"
				@click="$router.push({ path: '/user/adduser' })"
			>
				<i class="el-icon-arrow-left"></i>
				<span>用户管理/专栏信息</span>
			</div>
			<div class="add_main">
				<div style="height: 40px"></div>
				<span class="font_weight_bold">账号信息</span>
				<div class="margin_top_20">
					<el-form
						label-position="right"
						label-width="120px"
						:model="formData"
						:rules="rule"
						ref="formData"
					>
						<el-form-item label="注册邮箱" prop="email">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.email"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="用户密码" prop="password">
							<el-input v-model="formData.passwordNew"> </el-input>
						</el-form-item>

						<el-form-item label="确认密码" prop="password">
							<el-input v-model="formData.passwordNewCheck"> </el-input>
						</el-form-item>

						<el-form-item label="账号状态" prop="state">
							<el-select
								v-model="formData.state"
								:disabled="$route.query.type == 'detail'"
								placeholder="请选择账号状态"
							>
								<el-option label="正常" value="1"> </el-option>
								<el-option label="禁用" value="2"> </el-option>
							</el-select>
						</el-form-item>
						<div class="margin_top_40 font_weight_bold">专栏信息</div>

						<el-form-item label="专栏名称">
							<el-input
								v-model="formData.userinfo.company_name"
								:disabled="$route.query.type == 'detail'"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="专栏简介">
							<el-input
								v-model="formData.userinfo.company_desc"
								:disabled="$route.query.type == 'detail'"
							></el-input>
						</el-form-item>
						<el-form-item label="专栏LOGO" prop="avatar_img">
							<img
								style="width: 30%"
								v-if="formData.userinfo.company_logo"
								:src="formData.userinfo.company_logo"
								:disabled="$route.query.type == 'detail'"
								@click="uploadPicture('0')"
							/>
							<div v-else>
								<div class="el-upload__text" @click="uploadPicture(0)">
									<img
										style="width: 100px"
										src="../../../assets/images/uploadImg.png"
										alt=""
									/>
									<br /><em>点击加号上传</em></div
								>
							</div>
							<!-- 剪裁组件弹窗 -->
							<el-dialog
								title=""
								:visible.sync="cropperModel"
								width="1300px"
								center
								:append-to-body="true"
							>
								<cropper-image-new
									:Name="cropperName"
									:type="scale"
									:showType="2"
									:showAvator="true"
									@uploadImgSuccess="handleUploadSuccess"
									ref="child"
								>
								</cropper-image-new>
							</el-dialog>
						</el-form-item>

						<div class="margin_top_40 font_weight_bold">运营者信息</div>
						<el-form-item label="姓名" class="margin_top_20">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.userinfo.truename"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="手机号码">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.userinfo.phone"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="运营者邮箱">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.userinfo.contacts_email"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="Twitter">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.userinfo.social_media"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="Twitter认证链接">
							<el-input
								:disabled="$route.query.type == 'detail'"
								v-model="formData.userinfo.white_paper_url"
							>
							</el-input>
						</el-form-item>
						<div class="margin_top_40 font_weight_bold">认证状态</div>
						<el-form-item label="账号状态" prop="state">
							<el-select
								v-model="formData.userinfo.check_authentication"
								:disabled="$route.query.type == 'detail'"
								placeholder="请选择认证结果"
								change="handleChange"
							>
								<el-option label="通过" value="1"> </el-option>
								<el-option label="审核中" value="2"> </el-option>
								<el-option label="拒绝" value="3"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item
							v-if="formData.userinfo.check_authentication == 3"
							label="原因："
							class="margin_top_20"
						>
							<el-input
								v-model="formData.userinfo.auth_remark"
								class="custom_input_350"
								type="textarea"
								:rows="4"
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<div class="flex justify_content_c align_items_c">
								<el-button
									type="primary"
									v-if="$route.query.type != 'detail'"
									class="custom_btn_width_100"
									@click="submit('formData')"
								>
									保存
								</el-button>
								<el-button class="custom_btn_width_100" @click="$router.back()">
									返回
								</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { validateNull, identityCard, validatePhone } from "@/utils/validate";

import {
	uploadImage,
	getUsersdetails,
	createusers,
	updateusers,
} from "@/api/user";
export default {
	name: "",
	data() {
		return {
			rule: {
				nickname: [
					{ validator: validateNull, trigger: "blur", required: true },
				],
				email: [{ validator: validateNull, trigger: "blur", required: true }],
				state: [{ validator: validateNull, trigger: "change", required: true }],
			},
			value: "",
			formData: {
				state: "",
				nickname: "",
				mobile: "",
				avatar_img: "",
				sex: "",
				desc: "",
				position: "",
				email: "",
				wechat: "",
				twitter: "",
				document_type: "",
				passwordNew: "",
				passwordNewCheck: "",
				project_type: "",
				userinfo: {
					check_authentication: "",
					auth_remark: "",
					auth_type: "2",
					company_name: "",
					company_desc: "",
					company_no: "",
					company_img1: "",
					company_img2: "",
					project_logo: "",
					truename: "",
					id_card: "",
					id_card_img1: "",
					id_card_img2: "",
				},
			},
			//参数
			cropperModel: false,
			cropperName: "",
		};
	},
	created() {
		if (!this.$route.query.id) {
			this.clearFormAdd();
		} else {
			this.getUsersdetails();
		}
	},
	methods: {
		//封面设置
		uploadPicture(name) {
			this.cropperName = name;
			this.cropperModel = true;
		},
		//图片上传成功后
		handleUploadSuccess(data) {
			console.log(data.url);
			this.cropperModel = false;
			if (this.cropperName == "0") {
				this.formData.userinfo.company_logo = data.url;
			} else if (this.cropperName == "1") {
			} else if (this.cropperName == "2") {
			} else {
			}
		},
		handleChange() {},
		// 获取用户详情
		getUsersdetails() {
			const that = this;
			getUsersdetails({ d: that.$route.query.id })
				.then((res) => {
					if (res.code == 200) {
						that.formData = res.data;
						that.formData.state = that.formData.state.toString();
						if (!that.formData.userinfo.phone) {
							that.formData.userinfo.phone = that.formData.mobile;
						}
						if (!that.formData.userinfo.truename) {
							that.formData.userinfo.truename = that.formData.nickname;
						}

						// if (!that.formData.userinfo.contacts_email) {
						// 	that.formData.userinfo.contacts_email =
						// 		that.formData.contacts_email;
						// }

						that.formData.userinfo.check_authentication =
							that.formData.userinfo.check_authentication.toString();
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		// 新增
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const that = this;

					let form = {};
					if (
						this.formData.email != "" &&
						this.formData.email != null &&
						this.formData.email.length > 0
					) {
					} else {
						that.$message.error("请输入注册邮箱");
						return;
					}
					if (
						(this.formData.passwordNew != null &&
							this.formData.passwordNew.length > 0) ||
						(this.formData.passwordNewCheck != null &&
							this.formData.passwordNewCheck.length > 0)
					) {
						if (this.formData.passwordNew == this.formData.passwordNewCheck) {
							this.formData.password = this.formData.passwordNew;
						} else {
							that.$message.error("密码不一致，请确认！");
							return;
						}
					} else {
						delete this.formData.password;
					}

					this.formData.userinfo.auth_type = "2";

					if (
						this.formData.userinfo.company_logo != "" &&
						this.formData.userinfo.company_logo != null &&
						this.formData.userinfo.company_logo.length > 10
					) {
						this.formData.avatar_img = this.formData.userinfo.company_logo;
					} else {
						that.$message.error("专栏Logo不能为空！");
						return;
					}
					if (
						this.formData.userinfo.company_desc != "" &&
						this.formData.userinfo.company_desc != null &&
						this.formData.userinfo.company_desc.length > 0
					) {
						this.formData.desc = this.formData.userinfo.company_desc;
					} else {
						that.$message.error("专栏简介不能为空！");
						return;
					}
					if (
						this.formData.userinfo.company_name != "" &&
						this.formData.userinfo.company_name != null &&
						this.formData.userinfo.company_name.length > 0
					) {
						this.formData.nickname = this.formData.userinfo.company_name;
					} else {
						that.$message.error("专栏名称不能为空！");
						return;
					}

					if (
						this.formData.userinfo.contacts_email != "" &&
						this.formData.userinfo.contacts_email != null &&
						this.formData.userinfo.contacts_email.length > 10
					) {
						this.formData.contacts_email =
							this.formData.userinfo.contacts_email;
					}

					for (let key in this.formData) {
						if (key === "userinfo") {
							for (let key2 in this.formData.userinfo) {
								form[key2] = this.formData.userinfo[key2];
							}
						} else {
							form[key] = this.formData[key];
						}
					}
					if (this.$route.query.type == "edit") {
						updateusers(form)
							.then((res) => {
								if (res.code == 200) {
									// that.$router.push({ path: "/user/userlist" });
									this.$router.back();
								} else {
									that.$message.error(res.message);
								}
							})
							.catch((error) => {
								that.$message.error(error.message);
							});
					} else {
						createusers(form)
							.then((res) => {
								if (res.code == 200) {
									that.$router.push({ path: "/user/userlist" });
								} else {
									that.$message.error(res.message);
								}
							})
							.catch((error) => {
								that.$message.error(res.message);
							});
					}
					// }
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		// 上传图片
		uploadImagecompany1(obj) {
			const file = obj.file;
			let formdata = new FormData();
			formdata.append("file", file);
			const that = this;
			uploadImage(formdata)
				.then(function (res) {
					if (res.code == 200) {
						console.log(res.data.url);
						that.formData.userinfo.company_img1 = res.data.url;
					} else {
						that.$message.error(res.message);
					}
				})
				.catch(function (error) {
					this.$message.error(res.message);
				});
		},
		uploadImagecompany2(obj) {
			const file = obj.file;
			let formdata = new FormData();
			formdata.append("file", file);
			const that = this;
			uploadImage(formdata)
				.then(function (res) {
					if (res.code == 200) {
						console.log(res.data.url);
						that.formData.userinfo.company_img2 = res.data.url;
					} else {
						that.$message.error(res.message);
					}
				})
				.catch(function (error) {
					this.$message.error(res.message);
				});
		},

		uploadImagecard1(obj) {
			const file = obj.file;
			let formdata = new FormData();
			formdata.append("file", file);
			const that = this;
			uploadImage(formdata)
				.then(function (res) {
					if (res.code == 200) {
						console.log(res.data.url);
						that.formData.userinfo.id_card_img1 = res.data.url;
					} else {
						that.$message.error(res.message);
					}
				})
				.catch(function (error) {
					this.$message.error(res.message);
				});
		},
		uploadImagecard2(obj) {
			const file = obj.file;
			let formdata = new FormData();
			formdata.append("file", file);
			const that = this;
			uploadImage(formdata)
				.then(function (res) {
					if (res.code == 200) {
						console.log(res.data.url);
						that.formData.userinfo.id_card_img2 = res.data.url;
					} else {
						that.$message.error(res.message);
					}
				})
				.catch(function (error) {
					this.$message.error(res.message);
				});
		},
		clearFormAdd() {
			for (let key in this.formData) {
				if (key === "userinfo") {
					for (let key2 in this.formData.userinfo) {
						this.formData.userinfo[key2] = "";
					}
				} else {
					this.formData[key] = "";
				}
			}
			console.log(this.formData);
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}

.add_main {
	width: 70%;
	margin: 0 auto;
}
</style>
